import { ConflictsAction, getStatusesCurrentUserCanChangeHitsTo, HitMessages, HitStatus, HitStatuses, PermissionsContext, SearchVersion } from "aderant-conflicts-models";
import { ComboBoxItem } from "@aderant/aderant-react-components";

const getHitStatusComboBoxItem = (status: HitStatus): ComboBoxItem<HitStatus> => {
    switch (status) {
        case HitStatuses.Unactioned:
            return {
                displayName: HitMessages.HIT_STATUS_UNACTIONED.getMessage(),
                value: HitStatuses.Unactioned
            };
        case HitStatuses.NoConflict:
            return {
                displayName: HitMessages.HIT_STATUS_NOCONFLICT.getMessage(),
                value: HitStatuses.NoConflict
            };
        case HitStatuses.NotApplicable:
            return {
                displayName: HitMessages.HIT_STATUS_NOTAPPLICABLE.getMessage(),
                value: HitStatuses.NotApplicable
            };
        case HitStatuses.InProgress:
            return {
                displayName: HitMessages.HIT_STATUS_INPROGRESS.getMessage(),
                value: HitStatuses.InProgress
            };
        case HitStatuses.WaiverRequired:
            return {
                displayName: HitMessages.HIT_STATUS_WAIVERREQUIRED.getMessage(),
                value: HitStatuses.WaiverRequired
            };
        case HitStatuses.SeekingWaiver:
            return {
                displayName: HitMessages.HIT_STATUS_SEEKINGWAIVER.getMessage(),
                value: HitStatuses.SeekingWaiver
            };
        case HitStatuses.WaiverOnFile:
            return {
                displayName: HitMessages.HIT_STATUS_WAIVERONFILE.getMessage(),
                value: HitStatuses.WaiverOnFile
            };
        case HitStatuses.Conflict:
            return {
                displayName: HitMessages.HIT_STATUS_CONFLICT.getMessage(),
                value: HitStatuses.Conflict
            };
        case HitStatuses.Confirm:
            return {
                displayName: HitMessages.HIT_STATUS_CONFIRM.getMessage(),
                value: HitStatuses.Confirm
            };
    }
};

export const getHitStatusDisplayName = (status: HitStatus): string => {
    return getHitStatusComboBoxItem(status).displayName;
};

export const getAllHitStatuses = (): ComboBoxItem<HitStatus>[] => {
    return Object.values(HitStatuses).map((status) => getHitStatusComboBoxItem(status));
};

export const hitStatusList = (permissions: PermissionsContext, searchVersion?: SearchVersion, reviewerAllowedStatuses?: HitStatus[], defaultHitStatus?: HitStatus): ComboBoxItem<HitStatus>[] => {
    let result: HitStatus[] = Object.values(HitStatuses);
    const isReviewer = permissions.currentUserHasPermission(ConflictsAction.ChangeHitStatusOnHitsSharedToUser);
    if (isReviewer) {
        // For reviewers, only show statuses they're allowed to change to (from statusControl configuration)
        if (reviewerAllowedStatuses && reviewerAllowedStatuses.length > 0) {
            result = reviewerAllowedStatuses;
        }
        // Ensure the defaultHitStatus (current hit status) is included if not already present
        if (defaultHitStatus && !result.includes(defaultHitStatus)) {
            result = [defaultHitStatus, ...result];
        }
    } else if (searchVersion) {
        result = getStatusesCurrentUserCanChangeHitsTo(permissions, searchVersion);
    } else {
        result = Object.values(HitStatuses); // fallback if no context
    }
    return result.map((s) => getHitStatusComboBoxItem(s));
};
